import PropTypes from 'prop-types';
import { readingTime } from 'reading-time-estimator';
import styles from './helpTitle.module.scss';

function HelpTitle({
  title = '',
  publishDate = '',
  postContent = '',
  titleIcon = null,
}) {
  const stats = readingTime(postContent ?? '');
  const timeDuration = stats.text;
  return (
    <div className={styles.mainContainer}>
      {titleIcon && (
        <div className={styles.icon}>
          <img
            data-testid={titleIcon.path}
            src={titleIcon.path}
            alt={titleIcon.alt}
            loading="lazy"
            {...{
              ...(titleIcon.width && {
                width: titleIcon.width,
              }),
              ...(titleIcon.height && {
                height: titleIcon.height,
              }),
            }}
          />
        </div>
      )}
      <div className={!publishDate ? styles.contentWrapper : ''}>
        {title && (
          <h1
            className={publishDate ? styles.headline : styles.headlineOnly}
            itemProp="name"
          >
            {title}
          </h1>
        )}
        {publishDate && (
          <div className={styles.details}>
            <span
              itemType="https://schema.org/datePublished"
              itemProp="datePublished"
            >{`Last Updated ${publishDate}`}</span>
            {timeDuration && (
              <span
                data-testid={timeDuration}
                itemType="https://schema.org/timeRequired"
                itemProp="timeRequired"
              >
                {timeDuration}
              </span>
            )}
          </div>
        )}
      </div>
    </div>
  );
}
export default HelpTitle;

HelpTitle.propTypes = {
  title: PropTypes.string,
  publishDate: PropTypes.string,
  postContent: PropTypes.string,
  titleIcon: PropTypes.shape({
    path: PropTypes.string,
    alt: PropTypes.string,
  }),
};
